import React, { useEffect, useState } from "react";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import PieChartWithCenterLabel from "../Charts/DonutChart";
import { styled } from "@mui/material/styles";
import UnfoldMoreRoundedIcon from "@mui/icons-material/UnfoldMoreRounded";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { updateBranchClaim } from "../../actions/claim";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { deleteClaim } from "../../actions/claim";
import { createClaim } from "../../actions/claim";
import NumberToWords from "number-to-words";
import Logo from "../../assets/Logo.png";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { Modal, Watermark } from "antd";
import { printBranchClaim } from "../../actions/Approved";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import "./style.css";
import {
  Grow,
  TextField,
  MenuItem,
  Box,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  Paper,
  Tooltip,
  Table,
  TableRow,
  TableContainer,
  TableBody,
  TableHead,
  Container,
  Drawer,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import SimpleLineChart from "../Charts/LineChart";
import secureLocalStorage from "react-secure-storage";
import PieChartExpenses from "../Charts/DonutChart Expenses";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import toast from "react-hot-toast";
import BarChart from "../Charts/BarChart";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Draggable from "react-draggable";
import AdminDonutChart from "../Charts/AdminDonutChart";
import API from "../../Api/api";
import { Helmet } from "react-helmet-async";
import { getDownloadURL, ref } from "firebase/storage";
import { imageDb } from "../../Firebase/Config";
import { endOfMonth, startOfMonth } from "../../ui/today";
function PaperComponent(props) {
  return (
    <Draggable
      handle='#draggable-dialog-title'
      cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    fontWeight: "bold",
    fontSize: "12px",
  },
}));

function createData(
  id,
  claim_code,
  date,
  employee_name,
  branch,
  department,
  category,
  designation,
  description,
  sanctioned_by,
  approved_by,
  amount,
  payment_status,
  status,
  approvers_email,
  approvers_position
) {
  return {
    id,
    claim_code,
    date,
    employee_name,
    branch,
    department,
    category,
    designation,
    description,
    sanctioned_by,
    approved_by,
    amount,
    payment_status,
    status,
    approvers_email,
    approvers_position,
  };
}
function numberToWords(number) {
  const units = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
  ];
  const teens = [
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];
  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  if (number === 0) {
    return "zero";
  }

  function convert(number) {
    let words = "";

    if (number >= 1000000000) {
      words += convert(Math.floor(number / 1000000000)) + " billion, ";
      number %= 1000000000;
    }

    if (number >= 1000000) {
      words += convert(Math.floor(number / 1000000)) + " million, ";
      number %= 1000000;
    }

    if (number >= 1000) {
      words += convert(Math.floor(number / 1000)) + " thousand, ";
      number %= 1000;
    }

    if (number >= 100) {
      words += convert(Math.floor(number / 100)) + " hundred ";
      number %= 100;
    }

    if (number > 0) {
      if (words !== "") {
        words += "and ";
      }

      if (number < 10) {
        words += units[number] + " ";
      } else if (number < 20) {
        words += teens[number - 10] + " ";
        number = 0; // Skip further processing for teens
      } else {
        words += tens[Math.floor(number / 10)] + " ";
        number %= 10;
        if (number > 0) {
          words += units[number] + " ";
          number = 0; // Skip further processing for units
        }
      }
    }

    return words.trim();
  }

  const words = convert(number);
  return words;
}

export default function BranchDashboard() {
  const [showingData, setShowingData] = useState("data");
  const [rowData, setRowData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const showModal = () => {
    setOpenModal(true);
  };
  const handleOk = () => {
    setOpenModal(false);
  };
  const handleCancel = () => {
    setOpenModal(false);
  };
  const [open, setOpen] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const branchStats = useSelector((state) => state.branchStats);
  const approvedClaims = useSelector((state) => state.approved);
  const [approved, setApproved] = React.useState(approvedClaims);
  useEffect(() => {
    setApproved(approved);
  }, [approved]);

  const users = useSelector((state) => state.users);
  const branch = (
    user.results.branch[0] +
    user.results.branch[1] +
    user.results.branch[2]
  ).toUpperCase();
  const category = useSelector((state) => state.category.cart);
  const department = useSelector((state) => state.departments.depart);

  // const [open, setOpen] = React.useState(false);
  const approvers = users.filter((data) => data?.e_claim === "Approver");
  function generateRandomString() {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }

    return result;
  }

  const handleChangeDepartment = (event) => {
    setClaim({ ...claim, department: event.target.value });
  };
  const handleChangeAttention = (event) => {
    setClaim({ ...claim, attention_to: event.target.value });
  };
  const handleChangeCategory = (event) => {
    setClaim({ ...claim, category: event.target.value });
  };
  const handleChangeDesignation = (event) => {
    setClaim({ ...claim, designation: event.target.value });
  };
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const claims = useSelector((state) => state.claims.claims);
  const approvedAll = useSelector((state) => state.approved);
  const [approvedData, setApprovedData] = useState(approvedAll);
  const [claimsData, setClaimsData] = useState(claims);
  const approvedClaimsTotal = claimsData.filter(
    (data) => data.status === "approved"
  );
  const declinedClaimsTotal = claimsData.filter(
    (data) => data.status === "declined"
  );
  const pendingClaimsTotal = claimsData.filter(
    (data) => data.status === "pending"
  );
  const paidClaimsTotal = claimsData.filter(
    (data) => data.status === "approved"
  );
  const imprestClaimsTotal = claimsData.filter(
    (data) => data.category === "IMPREST"
  );
  const overdueImprestClaimsTotal = claimsData.filter(
    (data) =>
      data.category === "IMPREST" &&
      moment().diff(moment(data.date), "dayS") >= 14
  );
  const sanctionist = user?.results.firstName + " " + user?.results.lastName;
  const rows = approvedData
    .filter(
      (d) =>
        d.printed === "false" &&
        d.sanctioned_by === sanctionist &&
        d.branch === user?.results.branch
    )
    .map((data) =>
      createData(
        data._id,
        data.claim_code,
        moment(data.date).format("DD-MM-YYYY"),
        data.employee_name,
        data.branch,
        data.department,
        data.category,
        data.designation || "staff",
        data.description,
        data.sanctioned_by,
        data.approved_by,
        data.amount,
        data.payment_status,
        data.status,
        data.approvers_email,
        data.approvers_position
      )
    );
  React.useEffect(() => {
    setClaimsData(claims);
  }, [claims]);
  React.useEffect(() => {
    setApprovedData(approvedAll);
  }, [approvedAll]);
  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
  const code = `${branch}-${generateRandomString()}-${claims.length + 1}`;
  let [claim, setClaim] = React.useState({
    employee_name: "",
    department:
      user?.results.branch === "head office"
        ? ""
        : user?.results.branch.toUpperCase(),
    category: "",
    date: "",
    description: "",
    amount: "",
    sanctioned_by: user.results.firstName + " " + user.results.lastName,
    branch: user.results.branch,
    claim_code: "",
    status: "pending",
    payment_status: "Not paid",
    attention_to: "Anyone",
    designation: "",
    imprest_code: "",
    parent_category: "",
    imprest_amount: "",
  });
  claim.imprest_amount = claim.category === "IMPREST" ? claim.amount : "";
  claim.imprest_code = claim.category === "IMPREST" ? code : "";
  claim.claim_code = code;
  const dispatch = useDispatch();
  function sendData() {
    if (
      !claim.department &&
      !claim.category &&
      !claim.amount &&
      !claim.employee_name &&
      !claim.date &&
      !claim.description &&
      claim.designation
    ) {
      return toast.error("Please fill in required fields");
    }
    if (claim.amount * 1 <= 0) {
      return toast.error("Invalid amount");
    }

    setIsLoading(true);
    dispatch(createClaim(claim));
    setTimeout(() => {
      setIsLoading(false);
      setClaim({
        employee_name: "",
        department: "",
        category: "",
        date: "",
        description: "",
        amount: "",
        sanctioned_by: user.results.firstName + " " + user.results.lastName,
        branch: user.results.branch,
        claim_code: "",
        payment_status: "Not paid",
        attention_to: "Anyone",
        designation: "",
        imprest_code: "",
        parent_category: "",
        imprest_amount: "",
      });
    }, 3000);
  }
  const groupedData = paidClaimsTotal.reduce((result, item) => {
    const { category, id, amount } = item;
    if (!result[category]) {
      result[category] = {
        category,
        amount: 0,
      };
    }
    result[category].id = id;
    result[category].amount += amount;

    return result;
  }, {});

  // Converting the grouped data object back to an array (if needed)
  const groupedArray = Object.values(groupedData).sort(
    (a, b) => a.amount - b.amount
  );
  const name = [];
  const value = [];
  groupedArray.forEach((data) => {
    name.push(data.category.toLowerCase());
    value.push(data.amount);
  });
  const [dataShow, setDataShow] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  function handleOpenDialog() {
    setOpenDialog(true);
  }
  function handleCloseDialog() {
    setOpenDialog(false);
  }
  const columns = Object.keys(dataShow[0] || {})
    .filter((key) => key !== "_id")
    .map((key) => ({
      field: key,
      headerName: key,
      minWidth: 170,
      align: "left",
    }));
  const showData = (text) => {
    if (text === "all_imprest") {
      setDataShow(imprestClaimsTotal);
      handleOpenDialog();
      return;
    }
    if (text === "overdue_imprest") {
      setDataShow(overdueImprestClaimsTotal);
      handleOpenDialog();
      return;
    }
    if (text === "submitted_claims") {
      setDataShow(claimsData);
      handleOpenDialog();
      return;
    }
    if (text === "pending_claims") {
      setDataShow(pendingClaimsTotal);
      handleOpenDialog();
      return;
    }
    if (text === "approved_claims") {
      setDataShow(approvedClaimsTotal);
      handleOpenDialog();
      return;
    }
    if (text === "paid_claims") {
      setDataShow(paidClaimsTotal);
      handleOpenDialog();
      return;
    }
    if (text === "declined_claims") {
      setDataShow(declinedClaimsTotal);
      handleOpenDialog();
      return;
    }
  };
  const [filterData, setFilterData] = useState({
    start: "",
    end: "",
  });
  const getData = async () => {
    const start = filterData.start ? `&date[gte]=${filterData.start}` : "";
    const end = filterData.end ? `&date[lte]=${filterData.end}` : "";
    const branch = user?.results?.branch;
    const query = `/api/v1/eClaim?approved[eq]=true&branch[eq]=${branch}${start}${end}`;
    let loadingId;
    try {
      if (!start && !end) {
        toast.error("At least a field is required");
        return;
      }
      loadingId = toast.loading("Loading...");
      const { data } = await API.get(query);
      if (data.length === 0) {
        toast.remove(loadingId);
        toast.error("No data found");
        return;
      }
      setClaimsData(data);
      toast.remove(loadingId);
      toast.success("Loaded");
    } catch (error) {
      toast.remove(loadingId);
      toast.error(error?.message);
    }
  };
  function clearFilter() {
    if (!filterData.start || !filterData.end) {
      toast.error("There is nothing to clear");
      return;
    }
    if (showingData === "month") {
      const data = claims.filter(
        (d) =>
          moment(d.date) >= moment(startOfMonth) &&
          moment(d.date) < moment(endOfMonth)
      );
      setClaimsData(data);
      setFilterData({
        start: "",
        end: "",
      });
      return;
    }
    setClaimsData(claims);
    setFilterData({
      start: "",
      end: "",
    });
  }
  function approveBranchClaim(id, status) {
    if (status === "approved") {
      toast.error("This claim has already been approved");
      return;
    }
    dispatch(
      updateBranchClaim(id, {
        status: "approved",
        approved_by: user.results.firstName + " " + user.results.lastName,
        approvers_email: user.results.email,
        approvers_position: user.results.position,
      })
    );
  }

  function disableApprove(depart, amount) {
    const filter = department.filter((d) => d.department === depart);

    if (filter[0]?.limit >= amount) return false;
    if (filter[0]?.limit < amount) return true;
  }

  function deleteClaims() {
    dispatch(deleteClaim(deletingId));
    setDeletingId(null);
  }
  const handlePrint = async () => {
    // Define a timeout limit (in milliseconds)
    const TIMEOUT_LIMIT = 30000; // 5 seconds

    // Local message variable
    let message = "Loading...";

    // Create a new AbortController instance
    const controller = new AbortController();
    const { signal } = controller;

    // Toast loading message
    let printingId;
    try {
      printingId = toast.loading(message);

      // Set a timeout to abort the request if it takes too long
      const timeoutId = setTimeout(() => {
        controller.abort(); // Abort the request
        toast.remove(printingId);
        printingId = toast.error("please check your internet connection...");
        return;
      }, TIMEOUT_LIMIT);

      const fileName = rowData.approvers_email + "-claim.JPG";
      const storageRef = ref(imageDb, `profile_images/${fileName}`);

      // Fetch the download URL with a signal to abort if it takes too long
      const downloadURL = await getDownloadURL(storageRef).then(
        (url) => {
          clearTimeout(timeoutId); // Clear the timeout if successful
          return url;
        },
        (error) => {
          if (signal.aborted) {
            throw new Error("Network request timed out");
          }
          throw error; // If the error is something else, propagate it
        }
      );

      // Extract amount and convert to words
      const amountFirst = Math.floor(rowData.amount);
      const amountInWords = numberToWords(amountFirst);
      const decimalValue = (rowData.amount % 1).toFixed(2).split(".")[1];

      // Open new window for printing
      const printWindow = window.open("", "_blank");

      // Prepare HTML content for the print
      const content = `
    <html>
      <head>
        <title>Claim Form - ${rowData.employee_name}-${rowData.claim_code}-${
        rowData.branch
      }</title>
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap" rel="stylesheet">
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          body {
            font-family: 'Poppins', Arial, sans-serif;
            font-size: 12px;
            margin: 0;
            padding: 0;
            display: flex;
            border: 1px solid #000;
            border-radius: 15px;
            border-style: double;
            box-sizing: border-box;
            color: #09090b;
            height: 100dvh;
            background: repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px,
            rgba(0, 0, 0, 0.07) 30px,
            rgba(0, 0, 0, 0.1) 60px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 20px,
              rgba(0, 0, 0, 0.07) 30px,
              rgba(0, 0, 0, 0.1) 60px
            );
            background-attachment: fixed;
            background-size: 100px 100px;
          }
          .content {
            width: 100%;
            box-sizing: border-box;
            text-align: center;
            font-size: 12px;
          }
          .company_name {
            text-decoration: underline;
          }
          .signature {
          margin-top: -10px;
          margin-bottom: -10px;
            width: 150px;
            height: 60;
            mix-blend-mode: multiply;
            -webkit-user-drag: none;
            user-drag: none;
          }
          .watermark {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.2;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            z-index: -1;
          }
          .watermark span {
            font-size: 30px;
            font-weight: bold;
            color: #000;
            transform: rotate(-30deg);
            white-space: nowrap;
            opacity: 0.5;
          }
          .amount {
            font-weight: bold;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          th, td {
            border: 1px solid black;
            padding: 2px;
            text-align: left;
            font-size: 12px;
          }
          th {
            background-color: #ccc;
          }
          .company {
            width: 100%;
          }
          .claim-code {
            padding: 5px;
            background-color: #f1f1f1;
            font-weight: bold;
            border-radius: 25px;
            border: 2px solid #52525b;
          }
          .watermark_company {
            position: absolute;
            top: 15%;
            left: 50%;
            opacity: 0.3;
            transform: translate(-50%, -50%);
            font-size: 80px;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.2);
            pointer-events: none;
            z-index: -1;
          }
        @media print {
              
              @page { size: A5 landscape; }
              body {
              margin: 0; /* Remove default body margin */
              padding: 0; /* Remove default body padding */
              height: 100dvh; /* Allow body height to adjust based on content */
              line-height: 1.2;
              size: A5;
              orientation: landscape;
              
            }
            .content {
              page-break-inside: avoid; /* Prevent page break inside the content */
            }

            th {
              background-color: #ccc !important;
              -webkit-print-color-adjust: exact; 
              print-color-adjust: exact;
            }

            .claim-code {
              background-color: #ccc !important; 
              -webkit-print-color-adjust: exact; 
              print-color-adjust: exact;
            }

            .signature {
              mix-blend-mode: multiply;
            }
              
        }
        </style>
      </head>
      <body>
        <div class="watermark">
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
          <span>${rowData.claim_code} - Bosome Freho Rural Bank PLC</span>
        </div>
        <div class="content">
          <h2 class="company_name">Bosome Freho Rural Bank PLC Claim Form</h2>
          <img class="watermark_company" id="logoImage" src="${Logo}" alt="Company Logo" />
          <p class="company"><span class="amount">Employee's name:</span> ${
            rowData.employee_name
          }</p>
          <p class="company"><strong>Department</strong>:${
            rowData.department
          }</p>
         
          <table>
            <tr><th>Date</th><th>Description</th><th>Category</th><th>Amount</th></tr>
            <tr>
              <td>${rowData.date}</td>
              <td>${rowData.description}</td>
              <td>${rowData.category}</td>
              <td>${currencyFormatter.format(rowData.amount)}</td>
            </tr>
            <tr>
              <td colspan="4">
                <span class="amount">Amount in words:</span>
                <em>${amountInWords} Ghana cedis ${
        decimalValue > 0
          ? `, ${NumberToWords.toWords(decimalValue)} Ghana pesewas`
          : "only"
      }</em>
              </td>
            </tr>
          </table>
          <p class="amount company">Employee/recipient signature: ...............................................................</p>
          <p class="amount company">Sanctioned By: ${
            rowData.sanctioned_by
          } <span>Signature: ...................................</span></p>
          <p class="amount company">Approved by: ${rowData.approved_by}</p>
          <img class='signature' src=${downloadURL} oncontextmenu='return false' alt='signature'/>
          <p class="amount company">Position: ${rowData.approvers_position}</p>
          <p class="claim-code">Claim code: <em>${
            rowData.claim_code
          }</em> | <em>Branch</em>: ${rowData.branch} | <em>Status</em>: ${
        rowData.status
      }</p>
          <img class="qr-code" src="https://api.qrserver.com/v1/create-qr-code/?data=${
            rowData.status
          }&size=50x50" alt="QR Code" />
        </div>
      </body>
    </html>
    `;

      // Write the content and prepare for printing
      printWindow.document.open();
      printWindow.document.write(content);
      printWindow.document.close();

      // Wait for the content (including images) to load before printing
      printWindow.onload = () => {
        toast.remove(printingId);
        printWindow.print();
      };
      printWindow.onbeforeunload = () => {
        if (!printWindow.closed) {
          toast.error("You Just closed the print window");
        }
      };
      dispatch(
        printBranchClaim(rowData.id, {
          printed: "true",
          printed_by: user?.results.firstName + " " + user?.results.lastName,
          printed_date: Date.now(),
        })
      );
    } catch (error) {
      toast.remove(printingId);
      if (error.message === "Network request timed out") {
        toast.error(
          "The request took too long to complete. Please check your internet connection and try again."
        );
      } else {
        toast.error(
          "There was an issue fetching the signature image. Please check your internet connection and try again."
        );
      }
      console.error("Error fetching image:", error);
    }
  };

  useEffect(() => {
    if (showingData === "month") {
      const data = claims.filter(
        (d) =>
          moment(d.date) >= moment(startOfMonth) &&
          moment(d.date) < moment(endOfMonth)
      );
      setClaimsData(data);
    } else {
      setClaimsData(claims);
    }
  }, [showingData, claims]);

  return (
    <div
      style={{
        marginTop: "60px",
        borderTopLeftRadius: "40px",
      }}>
      <Modal
        maskClosable={false}
        closable={false}
        open={openModal}
        title='Printing Confirmation'
        onOk={handleOk}
        onCancel={handleCancel}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <Button
              onClick={() => {
                handlePrint();
                handleCancel();
              }}>
              Yes
            </Button>
            <Button
              style={{ color: "red" }}
              onClick={() => {
                handleCancel();

                setRowData([]);
              }}>
              No
            </Button>
          </>
        )}>
        <p>Do you want to proceed with printing this claim?</p>
      </Modal>

      <Helmet title='Dashboard - eClaim' />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'>
        <DialogTitle style={{ cursor: "move" }} id='draggable-dialog-title'>
          Data
        </DialogTitle>
        <DialogContent>
          <Paper>
            <DataGrid
              columns={columns}
              getRowId={(row) => row._id}
              rows={dataShow}
              slots={{ toolbar: GridToolbar }}
              style={{ height: "50vh" }}
              disableRowSelectionOnClick
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <div
        className='bounce-button'
        style={{
          position: "fixed",
          bottom: "10%",
          right: "2%",
          zIndex: 100,
        }}>
        <Tooltip title='Open Claim form'>
          <Button
            onClick={toggleDrawer(true)}
            className='new_claim_add'
            size='large'
            style={{
              backgroundColor: "#2C3E50",
              zIndex: 100,
              textTransform: "capitalize",
            }}>
            <HelpOutlineOutlinedIcon
              style={{
                fontWeight: 900,
                fontSize: "24px",
                color: "#ffffff",
              }}
            />
            <Typography style={{ color: "#ffffff" }}>New Claim</Typography>
          </Button>
        </Tooltip>
      </div>

      <Drawer
        anchor='top'
        style={{ height: "30vh", padding: "20px" }}
        open={open}
        onClose={toggleDrawer(false)}>
        <Watermark content={["Bosome Freho Rural Bank PLC"]}>
          <div style={{ position: "fixed", top: "1%", right: 0 }}>
            <Tooltip title='close drawer'>
              <IconButton
                style={{
                  backgroundColor: "#1abc9c",
                  border: "1px solid #000000",
                }}
                onClick={toggleDrawer(false)}>
                <CloseRoundedIcon style={{ color: "#ffffff" }} />
              </IconButton>
            </Tooltip>
          </div>
          <Container
            style={{
              padding: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <form>
              <Box
                marginBottom={2}
                display={"flex"}
                flexDirection={"row"}
                alignContent={"center"}
                alignItems={"center"}>
                <Typography
                  style={{ marginRight: "10px", fontWeight: "bold" }}
                  variant='body2'>
                  Company name:
                </Typography>
                <TextField
                  disabled
                  style={{
                    marginRight: "10px",
                  }}
                  variant='standard'
                  size='small'
                  required
                  value={"Bosome Freho Rural Bank PLC."}
                />
                <Typography
                  style={{
                    marginRight: "10px",
                    marginLeft: "20px",
                    fontWeight: "bold",
                  }}
                  variant='body2'>
                  Recipient name:
                </Typography>
                <TextField
                  required
                  placeholder='recipient name here'
                  type='text'
                  style={{
                    marginRight: "10px",

                    textTransform: "capitalize",
                  }}
                  variant='standard'
                  size='small'
                  value={claim.employee_name}
                  onChange={(e) =>
                    setClaim({ ...claim, employee_name: e.target.value })
                  }
                />
              </Box>
              <Box
                marginBottom={2}
                display={"flex"}
                flexDirection={"row"}
                alignContent={"center"}
                alignItems={"center"}
                justifyContent={"space-between"}
                width={200}>
                <FormControl variant='standard' sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel required id='demo-simple-select-standard-label'>
                    Department
                  </InputLabel>
                  <Select
                    disabled={
                      user?.results.branch === "head office" ? false : true
                    }
                    required
                    labelId='demo-simple-select-standard-label'
                    id='demo-simple-select-standard'
                    value={claim.department}
                    onChange={handleChangeDepartment}
                    label='department'>
                    <MenuItem value=''>
                      <em>None</em>
                    </MenuItem>
                    {department.map((data) => (
                      <MenuItem key={data._id} value={data.department}>
                        {data.department}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant='standard' sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel required id='demo-simple-select-standard-label'>
                    Category
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-standard-label'
                    id='demo-simple-select-standard'
                    value={claim.category}
                    onChange={handleChangeCategory}
                    label='Age'>
                    <MenuItem value=''>
                      <em>None</em>
                    </MenuItem>
                    {category.map((data) => (
                      <MenuItem key={data._id} value={data.category}>
                        {data.category}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant='standard' sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel required id='demo-simple-select-standard-label'>
                    Designation
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-standard-label'
                    id='demo-simple-select-standard'
                    value={claim.designation}
                    onChange={handleChangeDesignation}
                    label='Age'>
                    <MenuItem value=''>
                      <em>None</em>
                    </MenuItem>

                    <MenuItem value='staff'>Staff</MenuItem>
                    <MenuItem value='non-staff'>non-Staff</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant='standard' sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel id='demo-simple-select-standard-label'>
                    To The Attention Of
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-standard-label'
                    id='demo-simple-select-standard'
                    value={claim.attention_to}
                    onChange={handleChangeAttention}
                    label='Age'>
                    <MenuItem value='Anyone'>
                      <em>Anyone</em>
                    </MenuItem>
                    {approvers.map((data) => (
                      <MenuItem key={data._id} value={data.email}>
                        {data.position}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignContent={"center"}
                alignItems={"center"}>
                <Typography
                  style={{ marginRight: "10px", fontWeight: "bold" }}
                  variant='body2'>
                  Date<span style={{ color: "#000000" }}> *</span> :
                </Typography>
                <input
                  type='date'
                  required
                  style={{
                    marginRight: "10px",
                    border: "none",
                    borderBottom: "1px solid #000",
                  }}
                  size='small'
                  value={claim.date}
                  onChange={(e) => setClaim({ ...claim, date: e.target.value })}
                />
                <Typography
                  style={{
                    marginRight: "10px",
                    marginLeft: "20px",
                    fontWeight: "bold",
                  }}
                  variant='body2'>
                  Description:
                </Typography>
                <TextField
                  required
                  placeholder='description'
                  style={{
                    marginRight: "10px",
                  }}
                  variant='standard'
                  size='small'
                  value={claim.description}
                  onChange={(e) =>
                    setClaim({ ...claim, description: e.target.value })
                  }
                />
                <Typography style={{ fontWeight: "bold" }}>
                  Amount<span style={{ color: "#000000" }}> *</span>:
                </Typography>
                <input
                  required
                  placeholder='enter amount'
                  type='number'
                  variant='standard'
                  size='small'
                  style={{
                    marginLeft: "10px",
                  }}
                  value={claim.amount}
                  onChange={(e) =>
                    setClaim({ ...claim, amount: e.target.value })
                  }
                />
              </Box>
              <Button
                className='isLoading ? "loading" : ""'
                disabled={isLoading}
                onClick={sendData}
                style={{
                  marginTop: "10px",
                  backgroundColor: "#1abc9c",
                  color: "#ffffff",
                  border: "1px solid #000",
                  fontWeight: "bold",
                }}
                size='small'
                variant='contained'>
                {isLoading ? "Submitting..." : "submit claim"}
              </Button>
            </form>
          </Container>
        </Watermark>
      </Drawer>
      <div className=''>
        <div className='first-section'>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "8px",
              // backgroundColor: "#D7DED0",
              borderRadius: "25px",
              padding: "6px",
            }}>
            <div style={{ fontSize: "12px" }}>
              <HomeRoundedIcon style={{ color: "#2c3e50", fontSize: "18px" }} />{" "}
              / Dashboard / Analytics
            </div>
            <div>
              <div>
                <FormControl size='small'>
                  <FormLabel
                    style={{ fontSize: "12px" }}
                    id='demo-row-radio-buttons-group-label'>
                    Show Data For
                  </FormLabel>
                  <RadioGroup
                    value={showingData}
                    onChange={(e) => setShowingData(e.target.value)}
                    row
                    aria-labelledby='demo-row-radio-buttons-group-label'
                    name='row-radio-buttons-group'>
                    <FormControlLabel
                      value='month'
                      control={<Radio size='small' />}
                      label='This Month'
                    />
                    <FormControlLabel
                      value='data'
                      control={<Radio size='small' />}
                      label='All Data'
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              <span style={{ marginRight: "5px" }}>Filter | </span>{" "}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <TextField
                  size='small'
                  type='date'
                  label='Start Date'
                  InputLabelProps={{ shrink: true }}
                  value={filterData.start}
                  onChange={(e) =>
                    setFilterData({ ...filterData, start: e.target.value })
                  }
                />
                <TextField
                  size='small'
                  type='date'
                  label='End Date'
                  InputLabelProps={{ shrink: true }}
                  value={filterData.end}
                  onChange={(e) =>
                    setFilterData({ ...filterData, end: e.target.value })
                  }
                />
              </div>
              <Button
                onClick={getData}
                className='new_claim_button'
                size='small'
                style={{
                  backgroundColor: "#1abc9c",
                  marginLeft: "5px",
                  border: "1px solid #303846",
                  color: "#fff",
                }}>
                Filter
              </Button>
              <Tooltip title='clear filter'>
                <IconButton size='small' onClick={clearFilter}>
                  <ClearRoundedIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Paper
            elevation={0}
            style={{
              backgroundColor: "transparent",
              // border: "1px solid #27272a",
              padding: "5px",
              marginTop: "5px",
            }}>
            <div
              className='card-hover-effect-container'
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                marginTop: "5px",
                flexWrap: "wrap",
                columnGap: "10px",
                rowGap: "10px",
                backgroundColor: "transparent",
              }}>
              <Grow in timeout={1000}>
                <Tooltip title='click to view data'>
                  <Card
                    elevation={0}
                    className='card-hover-effect'
                    onClick={() => showData("submitted_claims")}
                    sx={{
                      minWidth: "60px",
                      maxWidth: "240px",

                      padding: 0,
                      cursor: "pointer",
                      flexGrow: 1,
                    }}>
                    <CardContent>
                      <Typography
                        sx={{ fontSize: 11, fontWeight: 800 }}
                        color='#17a689'
                        gutterBottom>
                        Submitted Claims
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                        color='text.secondary'>
                        {claimsData.length}
                      </Typography>
                    </CardContent>
                  </Card>
                </Tooltip>
              </Grow>
              <Grow in timeout={2000}>
                <Tooltip title='click to view data'>
                  <Card
                    elevation={0}
                    className='card-hover-effect'
                    onClick={() => showData("pending_claims")}
                    sx={{
                      minWidth: "60px",
                      maxWidth: "240px",

                      padding: 0,
                      cursor: "pointer",
                      flexGrow: 1,
                    }}>
                    <CardContent>
                      <Typography
                        sx={{ fontSize: 11, fontWeight: 800 }}
                        color='#facc15'
                        gutterBottom>
                        Pending Claims
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                        color='text.secondary'>
                        {pendingClaimsTotal.length}
                      </Typography>
                    </CardContent>
                  </Card>
                </Tooltip>
              </Grow>

              <Grow in timeout={3000}>
                <Tooltip title='click to view data'>
                  <Card
                    elevation={0}
                    className='card-hover-effect'
                    onClick={() => showData("approved_claims")}
                    sx={{
                      minWidth: "60px",
                      maxWidth: "240px",

                      padding: 0,
                      cursor: "pointer",
                      flexGrow: 1,
                    }}>
                    <CardContent>
                      <Typography
                        sx={{ fontSize: 11, fontWeight: 800 }}
                        color='#2ecc71'
                        gutterBottom>
                        Approved Claims
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                        color='text.secondary'>
                        {approvedClaimsTotal.length}
                      </Typography>
                    </CardContent>
                  </Card>
                </Tooltip>
              </Grow>

              <Grow in timeout={3000}>
                <Tooltip title='click to view data'>
                  <Card
                    elevation={0}
                    className='card-hover-effect'
                    onClick={() => showData("declined_claims")}
                    sx={{
                      minWidth: "60px",
                      maxWidth: "240px",

                      padding: 0,
                      cursor: "pointer",
                      flexGrow: 1,
                    }}>
                    <CardContent>
                      <Typography
                        sx={{ fontSize: 11, fontWeight: 800 }}
                        color='red'
                        gutterBottom>
                        Declined Claims
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                        color='text.secondary'>
                        {declinedClaimsTotal.length}
                      </Typography>
                    </CardContent>
                  </Card>
                </Tooltip>
              </Grow>
              <Grow in timeout={3000}>
                <Tooltip title='click to view data'>
                  <Card
                    elevation={0}
                    className='card-hover-effect'
                    onClick={() => showData("all_imprest")}
                    sx={{
                      minWidth: "60px",
                      maxWidth: "240px",

                      padding: 0,
                      cursor: "pointer",
                      flexGrow: 1,
                    }}>
                    <CardContent>
                      <Typography
                        sx={{ fontSize: 11, fontWeight: 800 }}
                        color='text.secondary'
                        gutterBottom>
                        Total Imprest
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                        color='text.secondary'>
                        {imprestClaimsTotal.length}
                      </Typography>
                    </CardContent>
                  </Card>
                </Tooltip>
              </Grow>
              <Grow in timeout={3000}>
                <Tooltip title='click to view data'>
                  <Card
                    elevation={0}
                    className='card-hover-effect'
                    onClick={() => showData("overdue_imprest")}
                    sx={{
                      minWidth: "60px",
                      maxWidth: "240px",
                      padding: 0,
                      cursor: "pointer",
                      flexGrow: 1,
                    }}>
                    <CardContent>
                      <Typography
                        sx={{ fontSize: 12, fontWeight: 800 }}
                        color='red'
                        gutterBottom>
                        Overdue Imprest
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 11,
                          fontWeight: 600,
                        }}
                        color='text.secondary'>
                        {overdueImprestClaimsTotal.length}
                      </Typography>
                    </CardContent>
                  </Card>
                </Tooltip>
              </Grow>
            </div>
          </Paper>
          {/* will come back */}
          <Paper
            elevation={0}
            style={{
              marginTop: "5px",
              borderRadius: "0px",
              borderTop: "2px solid #1abc9c",
            }}>
            <BarChart
              label={name}
              value={value}
              FilteredData={paidClaimsTotal}
              color={"#3e5871"}
              height={"40vh"}
            />
          </Paper>
        </div>
      </div>
      <Paper
        elevation={0}
        // className='table-paper'
        style={{
          // height: "60vh",
          overflow: "auto",
          padding: "10px",
          flexGrow: 1,
          margin: "10px",
          backgroundColor: "transparent",
          // border: "1px solid #27272a",
        }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-around",
            // backgroundColor: "#D7DED0",
          }}>
          <span style={{ color: "#303846" }}>
            {rows.length} Pending Claim{rows.length !== 1 ? "s" : ""} Details -
            Sanctioned By You
          </span>
          <Button
            className='new_claim_button'
            onClick={toggleDrawer(true)}
            size='small'
            style={{
              backgroundColor: "#1abc9c",
              color: "#ffffff",
              border: "1px solid #303846",
            }}>
            New Claim
          </Button>
          <Tooltip title='expand table'>
            <IconButton>
              <UnfoldMoreRoundedIcon style={{ color: "#303846" }} />
            </IconButton>
          </Tooltip>
        </div>
        <TableContainer
          component={Paper}
          elevation={0}
          style={{
            borderRadius: "0px",
            borderTop: "2px solid #1abc9c",
            width: "100%",
          }}>
          <Table
            elevation={0}
            stickyHeader
            size='small'
            sx={{
              minWidth: 650,
              width: "100%",
              "& tr > *:first-child": {
                position: "sticky",
                left: 0,
              },
              "& tr > *:last-child": {
                position: "sticky",
                right: 0,

                bgcolor: "#fff",
              },
            }}
            aria-label='a dense table'>
            <TableHead style={{ backgroundColor: "#75CA93 " }}>
              <TableRow style={{ backgroundColor: "#75CA93 " }}>
                <StyledTableCell align='left'>
                  <em>#</em>
                </StyledTableCell>
                <StyledTableCell width={"200px"} align='left'>
                  CODE
                </StyledTableCell>
                <StyledTableCell align='left'>DATE</StyledTableCell>
                <StyledTableCell align='left'>EMPLOYEE NAME</StyledTableCell>
                <StyledTableCell align='left'>BRANCH</StyledTableCell>
                <StyledTableCell align='left'>DEPARTMENT</StyledTableCell>
                <StyledTableCell align='left'>CATEGORY</StyledTableCell>
                <StyledTableCell align='left'>DESIGNATION</StyledTableCell>
                <StyledTableCell align='left'>SANCTIONED BY</StyledTableCell>
                <StyledTableCell align='left'>AMOUNT</StyledTableCell>
                <StyledTableCell align='left'>PAYMENT STATUS</StyledTableCell>
                <StyledTableCell align='left'>STATUS</StyledTableCell>
                <StyledTableCell
                  style={{ backgroundColor: "#fff" }}
                  align='left'>
                  ACTION
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}>
                  <StyledTableCell
                    style={{
                      fontWeight: "bold",
                      color: row.status === "approved" ? "#e2e8f0" : "",
                      backgroundColor:
                        row.status === "approved" ? "#16a34a" : "",
                    }}
                    align='left'
                    component='th'
                    scope='row'>
                    <em
                      style={{
                        fontWeight: "bold",
                      }}>
                      {index + 1}
                    </em>
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",
                    }}
                    align='left'
                    component='th'
                    scope='row'>
                    {row.claim_code}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",
                    }}
                    align='left'
                    component='th'
                    scope='row'>
                    {row.date}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",
                    }}
                    align='left'>
                    {row.employee_name}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",

                      textTransform: "capitalize",
                    }}
                    align='left'>
                    {row.branch}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",

                      textTransform: "capitalize",
                    }}
                    align='left'>
                    {row.department}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "250px",

                      textTransform: "capitalize",
                    }}
                    align='left'>
                    {row.category}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "250px",

                      textTransform: "capitalize",
                    }}
                    align='left'>
                    {row.designation}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",

                      textTransform: "capitalize",
                    }}
                    align='left'>
                    {row.sanctioned_by}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",
                    }}
                    align='left'>
                    {currencyFormatter.format(row.amount)}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",

                      textTransform: "capitalize",
                    }}
                    align='left'>
                    {row.payment_status}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      minWidth: "200px",

                      textTransform: "capitalize",
                    }}
                    align='left'>
                    {row.status}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#fff" }}
                    align='left'>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        columnGap: "5px",
                        flexGrow: 1,
                        height: "100%",
                        padding: 0,
                        margin: 0,
                      }}>
                      <Paper style={{ border: "1px solid #ccc" }}>
                        <Tooltip title='approve'>
                          <IconButton
                            onClick={(e) => {
                              e.preventDefault();
                              approveBranchClaim(row.id, row.status);
                            }}
                            size='small'
                            disabled={disableApprove(
                              row.department,
                              row.amount
                            )}>
                            <CheckCircleOutlinedIcon
                              style={{ fontSize: "18px" }}
                            />
                          </IconButton>
                        </Tooltip>
                      </Paper>
                      <Paper style={{ border: "1px solid #ccc" }}>
                        <Tooltip title='print'>
                          <IconButton
                            disabled={
                              row.status === "pending" ||
                              row.status === "declined"
                                ? true
                                : false
                            }
                            size='small'
                            onClick={() => {
                              setRowData(row);
                              showModal();
                            }}>
                            <PrintOutlinedIcon style={{ fontSize: "18px" }} />
                          </IconButton>
                        </Tooltip>
                      </Paper>
                      <Paper style={{ border: "1px solid #ccc" }}>
                        <Tooltip title='delete'>
                          <IconButton
                            onClick={() => {
                              setDeletingId(row.id);
                            }}
                            size='small'
                            disabled={
                              row.status === "pending" ||
                              row.status === "declined"
                                ? false
                                : true
                            }>
                            <DeleteOutlineIcon style={{ fontSize: "18px" }} />
                          </IconButton>
                        </Tooltip>
                      </Paper>
                    </div>
                    {deletingId === row.id && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}>
                        <Button
                          onClick={deleteClaims}
                          size='small'
                          style={{ color: "red" }}>
                          delete
                        </Button>
                        <Button
                          onClick={() => setDeletingId(null)}
                          size='small'>
                          Cancel
                        </Button>
                      </div>
                    )}
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Paper
        elevation={0}
        className='second-section'
        style={{
          backgroundColor: "transparent",
          // border: "1px solid #27272a",
        }}>
        {user?.results?.e_claim !== "Administrator" && (
          <PieChartExpenses claimData={paidClaimsTotal} />
        )}
        {user?.results?.e_claim === "Administrator" && (
          <AdminDonutChart claimData={approved} />
        )}
        {user?.results?.e_claim === "Approver" && (
          <AdminDonutChart claimData={approved} />
        )}

        <SimpleLineChart data={branchStats} />
        <PieChartWithCenterLabel claimData={paidClaimsTotal} />
      </Paper>
    </div>
  );
}
